/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
/**
 * All channels used by angular's WebWorker components are listed here.
 * You should not use these channels in your application code.
 */
exports.RENDERER_CHANNEL = 'ng-Renderer';
exports.EVENT_CHANNEL = 'ng-Events';
exports.ROUTER_CHANNEL = 'ng-Router';
//# sourceMappingURL=messaging_api.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser/src/web_workers/shared/messaging_api.js
// module id = 304
// module chunks = 2